export default __webpack_public_path__ + "static/media/ag-kids.3f022699.svg";